export default __webpack_public_path__ + "static/det-tillkommer-nya-casino-935ed59bc596969ed862ddc08c3294cf.jpg";